import { gql } from '@edreamsodigeo/frontend-api-client';

export const searchItineraryFragment = gql`
  fragment SearchItineraryFragment on SearchItineraryResult {
    isFareUpgradeAvailable
    key
    hotelXSellingEnabled
    meRating
    fees {
      price {
        amount
        currency
      }
      type
    }
    ticketsLeft
    legs {
      segmentKey
      segmentId
    }
    transportTypes
    carbonFootprintId
    campaignConfigId
    perks {
      primeDiscount {
        amount
        currency
      }
      extraPrimeCoupon {
        amount
        currency
      }
      primeDiscountPerPassenger {
        amount
        currency
      }
      extraPrimeCouponPerPassenger {
        amount
        currency
      }
      alternativeItineraryDiscount {
        amount
        currency
      }
      alternativeItineraryDiscountPerPassenger {
        amount
        currency
      }
    }
  }
`;
